import type { EcoCostsPayloadType, EcoCostsType } from "../../utils/ecoCostsUtils";

export const ECO_COSTS_SET_FAILED = "ecoCosts/setFailed";
export const ECO_COSTS_SET_DATA = "ecoCosts/setData";
export const ECO_COSTS_SET_ERRORS = "ecoCosts/setErrors";

type SetEcoCostsFailedType = { type: typeof ECO_COSTS_SET_FAILED; failed: boolean; payload: EcoCostsPayloadType };
type SetEcoCostsDataType = { type: typeof ECO_COSTS_SET_DATA; ecoCosts: EcoCostsType; payload: EcoCostsPayloadType };
type SetEcoCostsErrorsType = { type: typeof ECO_COSTS_SET_ERRORS; errors: string[] };

export const setEcoCostsFailed = (failed: boolean, payload: EcoCostsPayloadType): SetEcoCostsFailedType => ({
    type: ECO_COSTS_SET_FAILED,
    failed,
    payload,
});
export const setEcoCostsData = (ecoCosts: EcoCostsType, payload: EcoCostsPayloadType): SetEcoCostsDataType => ({
    type: ECO_COSTS_SET_DATA,
    ecoCosts,
    payload,
});
export const setEcoCostsErrors = (errors: string[]): SetEcoCostsErrorsType => ({
    type: ECO_COSTS_SET_ERRORS,
    errors,
});

export type EcoCostsActionsType = SetEcoCostsFailedType | SetEcoCostsDataType | SetEcoCostsErrorsType;
